import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {ProfileActivationDateSection} from '/component/partial/profile/ProfileActivationDateSection';
import {PROFILE_FIELD_COACH} from '/enum/profileField.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {
  activatedOnById,
  coachFullNameById,
} from '/redux/selector/client.selector';
import {withHOC} from '/util/hoc.util';

export default withHOC(
  connect(
    createStructuredSelector({
      coachName: coachFullNameById,
      dateJoined: activatedOnById,
    }),
    null,
    (stateProps, dispatchProps, ownProps) => ({
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      fields: [PROFILE_FIELD_COACH],
    }),
  ),
  withTranslation('screen.clientProfile.section.date.joined'),
)(ProfileActivationDateSection);
